import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output, Injectable } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TmQueueService } from '@app/_core/services/tm-queue.service';

import { QueuesService } from '@app/_core/services/queues.service';

import { DialerComponent } from 'src/app/_core/components/dialer/dialer.component';

import { DialerService } from '@app/_core/services/dialer.service';

import { AppService } from '@app/_core/services/app.service';

let callers: any = null;
let showConference: boolean = false;
@Injectable({ providedIn: 'root' })
@Component({
	selector: 'app-transfer-participant',
	templateUrl: './transfer-participant.component.html',
	styleUrls: ['./transfer-participant.component.scss'],
})
export class TransferParticipantComponent implements OnInit {
	
	//@Output() CallTransfer_showConference: EventEmitter<any> = new EventEmitter<any>();
	
	
	conferenceList: any;
	callersUserCountText: any;
	callersInternalCountText: any;
	callersExternalCountText: any;
	
	constructor(
		public bsModalRef: BsModalRef,
		private modalService: BsModalService,
		private tmQueueService: TmQueueService,
		private queueServices: QueuesService,
		
		private dialerComponent: DialerComponent,
		
		private dialerService: DialerService,
		
		private appService: AppService,
		@Inject(APP_BASE_HREF) public baseHref: string
	) {
		this.dialerService.callEnded.subscribe((val: boolean) => {
			if (val) {
				this.closeTaskSelectionMenu();
			}
			// if (val) this.hangUp();
		});
		this.dialerService.callDisconnected.subscribe(value => {
			if (value) {
				this.closeTaskSelectionMenu();
			}
		});
		//this.CallTransfer_showConference.subscribe(val => {

		//	showConference = val;

		//});
		//this.queueServices.CallTransfer_ShowConferenceList.subscribe(val => {
			
		//	showConference = val;
			
		//});
	}

	ngOnInit(): void {

		//this.clearconferencelist();
		this.populateConferenceList();
	}
	getshowConference() {
		return showConference;
    }
	populateConferenceList1() {
		var activecallers = this.queueServices.getactivecallers();
		if (activecallers) {
			callers = activecallers;
		//	console.log(activecallers);
		}
		//if (this.callers == null || this.callers.length == 0)
		//	return false;

		//var x, y;
		//for (x = 0, y = this.callers.length; x < y; x++) {
		//	if (this.callers[x].UserID == userid)
		//		return true;
		//}
		//return false;
	}


	closeTaskSelectionMenu() {
		this.bsModalRef.hide();
		//showConference = false;
	}
	clearconferencelist() {
		this.queueServices.setconferencelist(null);
	}

	closeModal() {

    }
	
	populateConferenceList = function () {
		var data = this.queueServices.getactivecallers();

		if (data == null) {
			return;
		}

		if (this.lastCallers != null) {
			if (JSON.stringify(data) == JSON.stringify(this.lastCallers))
				return;
		}

			this.lastCallers = data;
		
		// Get Counts per User Type
		var counts = {
			User: 0,
			Agent: 0,
			ThirdParty: 0
		};

		for (var i = 0; i < data.length; i++) {
			if (data[i].UserType != 'Manager')
				counts[data[i].UserType]++;

			data[i].ishold = false;
		}

		this.callersUserCountText =(counts.User + ' User' + ((counts.User != 1) ? 's  ' : '  '));
		this.callersInternalCountText=(counts.Agent + ' Agent' + ((counts.Agent != 1) ? 's  '  : '  '));
		this.callersExternalCountText=(counts.ThirdParty + '  External');

	//var itemCount = this.conferenceList.length;
	//var itemsToRemove = [];

	//// Update Existing Callers / Mark Disconnected Callers for Removal
	//	for (var i = 0; i < itemCount; i++) {
	//		var item = data[i];
	//	var callID = item.CallID;
	//	var callIndex = this.getArrayIndex(data, callID, 'CallID');
	//	if (callIndex != -1) {
	//		item.data(data[callIndex]);
	//		data.splice(callIndex, 1);
	//	} else {
	//		itemsToRemove.push(item);
	//	}
	//}

	// Remove Disconnected Callers
	//for (var i = 0; i < itemsToRemove.length; i++) {
	//	conferenceList.removeItem(itemsToRemove[i], true);
	//}

	//// Add New Callers
	//for (var i = 0; i < data.length; i++) {
	//	if (data[i].UserType != 'Manager') {
	//		conferenceList.addItem(new im.PhoneCallerListItem(data[i]));
	//	}
	//}

		callers = data;
		this.queueServices.setconferencelist(data);
	}

	getArrayIndex = function (array, search, propName) {
		for (var i = 0; i < array.length; i++) {
			if (propName != null) {
				if (array[i][propName] == search) {
					return i;
				}
			} else if (array[i] == search) {
				return i;
			}
		}
		return -1;
	}
	HoldCall(data) {
		var activeconfcallers = this.queueServices.getconferencelist();

		if (!activeconfcallers) {
			activeconfcallers = this.queueServices.getactivecallers();
		}
		var callID = data.CallID;
		var callIndex = this.getArrayIndex(activeconfcallers, callID, 'CallID');
			if (callIndex != -1) {
				//item.data(data[callIndex]);
				//data.splice(callIndex, 1);
				if (!activeconfcallers[callIndex].ishold) {
					activeconfcallers[callIndex].ishold = true;

				} else {
					activeconfcallers[callIndex].ishold = false;

				}
			} else {
				//itemsToRemove.push(item);
			}
			
		if (activeconfcallers[callIndex].UserType == 'User') {

			this.ToggleHoldCallerUser(callID, activeconfcallers[callIndex].ishold);

		}
		else {
			this.ToggleHoldAgentUser(callID, activeconfcallers[callIndex].ishold);
		}
		
		callers = activeconfcallers;
		this.queueServices.setconferencelist(activeconfcallers);
	}
	ToggleHoldCallerUser(callID, ishold) {
		this.dialerComponent.toggleHold.emit({ val: ishold, shouldcallapi: true });
	}

	ToggleHoldAgentUser(callID, ishold) {
		if (ishold) {
			this.tmQueueService.holdCall(callID, true).subscribe(data => {
			//	console.log(data);
			});
		}
		else {
			//this.tmQueueService.resumeCall(callID, true, false).subscribe(data => {
			//	console.log(data);
			//});
        }
	}

	DisconnectCall(data) {
		var callID = data.CallID;
		//this.tmQueueService.CancelCall(false,callID).subscribe(data => {
		//	console.log(data);
		//});
		this.RemovecallerfromList(callID);
		//this.populateConferenceList();
	}

	RemovecallerfromList(callID) {
		var data = this.queueServices.getconferencelist();

		var callIndex = this.getArrayIndex(data, callID, 'CallID');
		if (callIndex != -1) {
			data.splice(callIndex, 1);
		} else {
			//itemsToRemove.push(item);
		}

		// Remove Disconnected Callers
		//for (var i = 0; i < itemsToRemove.length; i++) {
		//	conferenceList.removeItem(itemsToRemove[i], true);
		//}
		//console.log(data);
		//console.log(callers);
		callers = data;
		this.queueServices.setconferencelist(data);

	}

	getCallersList() {
		var data = this.queueServices.getconferencelist();
		//console.log('caller list',callers);
		return data;
	}

	formatPhoneNumber = function (number, country) {
		switch (country) {
			case 'US':
			default:
				number = number.replace(/\D/g, '');
				if (number.charAt(0) == '1')
					number = number.substring(1);
				if (number.length == 7)
					return number.substring(0, 3) + '-' + number.substring(3);
				if (number.length == 10)
					return '(' + number.substring(0, 3) + ') ' + number.substring(3, 6) + '-' + number.substring(6);
				if (number.length > 10)
					return '(' + number.substring(0, 3) + ') ' + number.substring(3, 6) + '-' + number.substring(6, 10) + ' x' + number.substring(10);
				return number;
		}
	}
}
